const OrderCardActionTypes = {
  CHANGE_SCREEN: 'change_screen',
  UPDATE_USER: 'update_user',
  FORCE_UPDATE: 'force_update',
  FORCE_RESET: 'force_reset',
  UPDATE_CARD_ORDER_SETTINGS: 'update_card_order_setting',
  UPDATE_MAIN_CARD_TYPE: 'update_main_card_type',
  UPDATE_CARD_TYPE: 'update_card_type',
  UPDATE_CARD_CURRENCY: 'update_card_currency',
  UPDATE_FREE_CARD_ELIGIBLE: 'update_free_card_eligible',
  UPDATE_PAYMENT_INFO: 'update_payment_info',
  UPDATE_USER_WALLETS: 'update_user_wallets',
  UPDATE_CHOSEN_WALLET_FOR_PAYMENT: 'update_chosen_wallet_for_payment',
  UPDATE_CARD_PROVIDER: 'update_card_provider',
  UPDATE_CARD_HOLDER_NAME: 'update_card_holder_name',
  UPDATE_REGION_SETTING: 'update_region_settings',
  UPDATE_CARD_OPTIONS: 'update_card_options',
  UPDATE_CARD_ORDER_FEE: 'update_card_order_fee',
  UPDATE_ACCOUNT_MAILING_ADDRESS: 'update_account_mailing_address',
  UPDATE_IS_REPLACEMENT_CARD: 'update_is_replacement_card',
  UPDATE_ORDERABLE_CARD_TYPE: 'update_orderable_card_type',
  UPDATE_CARD_ISSUE_OPTIONS: 'update_card_issue_options',
  UPDATE_CARD_NETWORK: 'update_card_network',
  UPDATE_CARD_PROVIDER_WITH_TYPES: 'update_card_providers_with_types',
};

const OrderCardReducer = (state, action) => {
  switch (action.type) {
    case OrderCardActionTypes.CHANGE_SCREEN:
      return {
        ...state,
        currentScreen: action.payload.screen,
        screenOptions: action.payload.options,
      };
    case OrderCardActionTypes.FORCE_UPDATE:
      return {
        ...state,
        forceUpdate: {
          ...state.forceUpdate,
          [`${action.payload.key}`]: action.payload.value,
        },
      };
    case OrderCardActionTypes.FORCE_RESET:
      return {
        ...state,
        forceReset: {
          ...state.forceReset,
          [`${action.payload.key}`]: action.payload.value,
        },
      };
    case OrderCardActionTypes.UPDATE_USER:
      return {
        ...state,
        user: action.payload,
      };
    case OrderCardActionTypes.UPDATE_CARD_ORDER_SETTINGS:
      return {
        ...state,
        cardOrderSettings: {
          ...state.cardOrderSettings,
          [`${action.payload.key}`]: action.payload.settings,
        },
      };

    case OrderCardActionTypes.UPDATE_MAIN_CARD_TYPE:
      return { ...state, mainCardType: action.payload };

    case OrderCardActionTypes.UPDATE_CARD_TYPE:
      return { ...state, cardType: action.payload };

    case OrderCardActionTypes.UPDATE_PAYMENT_INFO:
      return {
        ...state,
        payment: {
          ...state.payment,
          [`${action.payload.key}`]: action.payload.value,
        },
      };
    case OrderCardActionTypes.UPDATE_USER_WALLETS:
      return { ...state, userWallets: action.payload };

    case OrderCardActionTypes.UPDATE_FREE_CARD_ELIGIBLE:
      return { ...state, freeCardEligible: action.payload };

    case OrderCardActionTypes.UPDATE_CHOSEN_WALLET_FOR_PAYMENT:
      return { ...state, chosenWalletForPayment: action.payload };

    case OrderCardActionTypes.UPDATE_CARD_PROVIDER:
      return { ...state, cardProvider: action.payload };

    case OrderCardActionTypes.UPDATE_REGION_SETTING:
      return { ...state, regionSettings: action.payload };

    case OrderCardActionTypes.UPDATE_CARD_HOLDER_NAME:
      return { ...state, cardHolderName: action.payload };

    case OrderCardActionTypes.UPDATE_CARD_CURRENCY:
      return { ...state, cardCurrency: { coin: action.payload } };

    case OrderCardActionTypes.UPDATE_CARD_OPTIONS:
      return { ...state, cardOptions: action.payload };

    case OrderCardActionTypes.UPDATE_CARD_ORDER_FEE:
      return { ...state, cardOrderFee: action.payload };

    case OrderCardActionTypes.UPDATE_ACCOUNT_MAILING_ADDRESS:
      return { ...state, accountMailingAddress: action.payload };

    case OrderCardActionTypes.UPDATE_IS_REPLACEMENT_CARD:
      return { ...state, isCardReplacement: action.payload };

    case OrderCardActionTypes.UPDATE_ORDERABLE_CARD_TYPE:
      return { ...state, orderableCardTypes: action.payload };

    case OrderCardActionTypes.UPDATE_CARD_ISSUE_OPTIONS:
      return { ...state, cardIssueOptions: action.payload };

    case OrderCardActionTypes.UPDATE_CARD_NETWORK:
      return { ...state, cardNetwork: action.payload };

    case OrderCardActionTypes.UPDATE_CARD_PROVIDER_WITH_TYPES:
      return { ...state, cardProvidersWithTypesObj: action.payload };

    default:
      return state;
  }
};

const openScreen =
  (dispatch) =>
  (screen, options = {}) =>
    dispatch({ type: OrderCardActionTypes.CHANGE_SCREEN, payload: { screen, options } });

const forceUpdateAction = (dispatch) => (key, value) =>
  dispatch({ type: OrderCardActionTypes.FORCE_UPDATE, payload: { key, value } });

const forceResetAction = (dispatch) => (key, value) =>
  dispatch({ type: OrderCardActionTypes.FORCE_RESET, payload: { key, value } });

const updateUser = (dispatch) => (userData) =>
  dispatch({ type: OrderCardActionTypes.UPDATE_USER, payload: userData });

const updateCardIssueOptions = (dispatch) => (options) =>
  dispatch({ type: OrderCardActionTypes.UPDATE_CARD_ISSUE_OPTIONS, payload: options });

const updateCardOrderSettings = (dispatch) => (key, settings) =>
  dispatch({ type: OrderCardActionTypes.UPDATE_CARD_ORDER_SETTINGS, payload: { key, settings } });

const updateMainCardType = (dispatch) => (mainCardType) =>
  dispatch({ type: OrderCardActionTypes.UPDATE_MAIN_CARD_TYPE, payload: mainCardType });

const updateCardType = (dispatch) => (cardType) =>
  dispatch({ type: OrderCardActionTypes.UPDATE_CARD_TYPE, payload: cardType });

const updatePaymentInfo = (dispatch) => (key, value) =>
  dispatch({ type: OrderCardActionTypes.UPDATE_PAYMENT_INFO, payload: { key, value } });

const updateUserWallets = (dispatch) => (wallets) =>
  dispatch({ type: OrderCardActionTypes.UPDATE_USER_WALLETS, payload: wallets });

const updateFreeCardEligible = (dispatch) => (cardEligible) =>
  dispatch({ type: OrderCardActionTypes.UPDATE_FREE_CARD_ELIGIBLE, payload: cardEligible });

const updateChosenWalletForPayment = (dispatch) => (wallet) =>
  dispatch({ type: OrderCardActionTypes.UPDATE_CHOSEN_WALLET_FOR_PAYMENT, payload: wallet });

const updateCardProvider = (dispatch) => (cardProvider) =>
  dispatch({ type: OrderCardActionTypes.UPDATE_CARD_PROVIDER, payload: cardProvider });

const updateCardHolderName = (dispatch) => (holderName) =>
  dispatch({ type: OrderCardActionTypes.UPDATE_CARD_HOLDER_NAME, payload: holderName });

const updateUserRegionSettings = (dispatch) => (regionSettings) =>
  dispatch({ type: OrderCardActionTypes.UPDATE_REGION_SETTING, payload: regionSettings });

const updateCardCurrency = (dispatch) => (coin) =>
  dispatch({ type: OrderCardActionTypes.UPDATE_CARD_CURRENCY, payload: coin });

const updateCardOrderFee = (dispatch) => (fee) =>
  dispatch({
    type: OrderCardActionTypes.UPDATE_CARD_ORDER_FEE,
    payload: fee,
  });

const updateCardOptions = (dispatch) => (options) =>
  dispatch({
    type: OrderCardActionTypes.UPDATE_CARD_OPTIONS,
    payload: options,
  });

const updateAccountMailingAddress = (dispatch) => (mailingAddress) =>
  dispatch({
    type: OrderCardActionTypes.UPDATE_ACCOUNT_MAILING_ADDRESS,
    payload: mailingAddress,
  });

const updateIsReplacementCard = (dispatch) => (isReplacement) =>
  dispatch({
    type: OrderCardActionTypes.UPDATE_IS_REPLACEMENT_CARD,
    payload: isReplacement,
  });

const updateOrdarableCardType = (dispatch) => (cardTypes) =>
  dispatch({
    type: OrderCardActionTypes.UPDATE_ORDERABLE_CARD_TYPE,
    payload: cardTypes,
  });

const updateCardNetwork = (dispatch) => (cardNetwork) =>
  dispatch({
    type: OrderCardActionTypes.UPDATE_CARD_NETWORK,
    payload: cardNetwork,
  });

const updateCardProvidersWithTypes = (dispatch) => (item) =>
  dispatch({
    type: OrderCardActionTypes.UPDATE_CARD_PROVIDER_WITH_TYPES,
    payload: item,
  });

// eslint-disable-next-line import/prefer-default-export
export const orderCard = {
  OrderCardReducer,
  actions: {
    openScreen,
    updateUser,
    forceUpdateAction,
    forceResetAction,
    updateCardOrderSettings,
    updateMainCardType,
    updateCardType,
    updatePaymentInfo,
    updateUserWallets,
    updateFreeCardEligible,
    updateChosenWalletForPayment,
    updateCardProvider,
    updateCardHolderName,
    updateUserRegionSettings,
    updateCardCurrency,
    updateCardOptions,
    updateCardOrderFee,
    updateAccountMailingAddress,
    updateIsReplacementCard,
    updateOrdarableCardType,
    updateCardIssueOptions,
    updateCardNetwork,
    updateCardProvidersWithTypes,
  },
};
